export default __webpack_public_path__ + "static/media/6.ef2660ab.webp";